import React, { Component } from 'react'
import autoBind from 'auto-bind'
import { withStyles } from '@material-ui/core/styles'
import { Translate } from 'react-localize-redux'

import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import ListItemText from '@material-ui/core/ListItemText'
import IconButton from '@material-ui/core/IconButton'
import SampleIcon from '@material-ui/icons/LocalShipping'
import DeleteIcon from '@material-ui/icons/DeleteOutline'
import Grid from '@material-ui/core/Grid'
import Tooltip from '@material-ui/core/Tooltip'
import { TextField, Paper } from '@material-ui/core'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import FormControl from '@material-ui/core/FormControl'
import Typography from '@material-ui/core/Typography'

import PlotSelector from '../../common/PlotSelector'
import SuppliersSelector from '../../common/SupplierSelector'
import Evidence from '../../common/Evidence'

class ItemDialog extends Component {
	constructor(props) {
		super(props)
		autoBind(this)
		this.state = {
			comments: this.props.item ? this.props.item.comments : '',
		}
	}

	componentDidUpdate(prevProps) {
		if (this.props.item !== prevProps.item) {
			this.setState({
				comments: this.props.item.comments,
			})
		}
	}

	onRemoveSupplierClick(item, quote) {
		if (this.props.onRemoveSupplier) {
			this.props.onRemoveSupplier(item, quote.supplier_token)
		}
	}

	onAddSampleRequestSupplierClick(item, quote) {
		if (this.props.onAddSampleRequestSupplier) {
			this.props.onAddSampleRequestSupplier(item, quote)
		}
	}

	onRemoveSampleRequestSupplierClick(item, quote) {
		if (this.props.onRemoveSampleRequestSupplier) {
			this.props.onRemoveSampleRequestSupplier(item, quote.supplier_token)
		}
	}

	handleUploadFiles(files) {
		if (this.props.uploadFiles)
			return this.props.uploadFiles(files, this.props.item.token)
				.then(() => Promise.resolve('Ok'))
				.catch(() => Promise.reject())
	}

	handleRemoveFiles(fileName) {
		if (this.props.removeFiles)
			return this.props.removeFiles(fileName, this.props.item.token)
				.then(() => Promise.resolve('Ok'))
				.catch(() => Promise.reject())
	}

	updateProperty(property, value) {
		this.setState({ [property]: value })
	}

	onAddComment(item) {
		if (this.props.onAddComment) this.props.onAddComment(item, this.state.comments)
	}

	onRequieredRMI(item, quote, value) {
		if (this.props.onAddRMISampleRequestSupplier) {
			this.props.onAddRMISampleRequestSupplier(item, quote, value)
		}
	}

	getSelectedSuppliers() {
		const { classes, item } = this.props
		if (!item.quotes || item.quotes.length === 0) {
			return (
				<Typography variant='caption'>
					<Translate id='common.withoutSuppliers' />
				</Typography>
			)
		}
		return item.quotes.map((quote) => (
			<ListItem key={quote.quote_token || quote.supplier_token} dense divider>
				<ListItemText primary={`${quote.supplier_code} | ${quote.supplier_name}`} />
				<ListItemSecondaryAction>
					<React.Fragment>
						{quote.is_sample_requiered === true && (
							<FormControl component='fieldset' className={classes.formControl}>
								<FormControlLabel
									control={
										<Checkbox
											checked={quote.is_rmi_requiered}
											onChange={(event) => {
												this.onRequieredRMI(item, quote, event.target.checked)
											}}
										/>
									}
									label={'RMI'}
								/>
							</FormControl>
						)}
						{quote.is_sample_requiered === true ? (
							<Tooltip title={<Translate id='memos.removeRequestSampleTooltipMessage' />}>
								<IconButton
									color='primary'
									onClick={() => {
										this.onRemoveSampleRequestSupplierClick(item, quote)
									}}
								>
									<SampleIcon />
								</IconButton>
							</Tooltip>
						) : (
							<Tooltip title={<Translate id='memos.requestSampleTooltipMessage' />}>
								<IconButton
									onClick={() => {
										this.onAddSampleRequestSupplierClick(item, quote)
									}}
								>
									<SampleIcon />
								</IconButton>
							</Tooltip>
						)}
						<Tooltip title={<Translate id='memos.removeSupplierRequestTooltipMessage' />}>
							<IconButton
								className={classes.deleteButton}
								onClick={() => {
									this.onRemoveSupplierClick(item, quote)
								}}
							>
								<DeleteIcon />
							</IconButton>
						</Tooltip>
					</React.Fragment>
				</ListItemSecondaryAction>
			</ListItem>
		))
	}

	render() {
		const { item, classes } = this.props
		if (!item) return null
		return (
			<Dialog open={this.props.show}>
				<DialogTitle>
					<Translate id='deliveryOrderModule.materialsTable.plot' />: {item.part_number} Rev. {item.review}
				</DialogTitle>
				<DialogContent>
					<Grid container spacing={0}>
						<Grid item xs={12} className={classes.gridItem}>
							<PlotSelector
								specPlano={item.plano_number}
								revision={item.review}
								selectedPlotName={item.plot_name}
								formatype='Memos'
								onPlotSelected={(plot) => {
									this.props.onPlotSelected(item, plot)
								}}
							/>
						</Grid>
						<Grid item xs={12} className={classes.gridItem}>
							<Typography variant='caption'>
								<Translate id='plotSelector.addComments' />
							</Typography>
							<TextField
								key={'comments'}
								fullWidth
								variant='outlined'
								multiline
								rowsMax='3'
								value={this.state['comments'] ? this.state['comments'] : ''}
								onChange={(event) => {
									this.updateProperty('comments', event.target.value)
								}}
								onBlur={() => this.onAddComment(item)}
							/>
						</Grid>
						<Grid item xs={12} className={classes.gridItem}>
							<Typography variant='caption' gutterBottom>
								<Translate id='memos.addSupplierToMemoMessage' />
							</Typography>
							<SuppliersSelector
								onSupplierSelected={(supplier) => {
									this.props.onSupplierSelected(item, supplier)
								}}
							/>
							<Paper style={{ maxHeight: 110, minHeight: 0, overflowY: 'auto', marginTop: 5 }}>
								<List dense>{this.getSelectedSuppliers()}</List>
							</Paper>
						</Grid>
						<Grid item xs={12} className={classes.gridItem}>
							<Typography variant='caption'>
								<Translate id='common.attachments' />
							</Typography>
							<Evidence
								text={this.props.dropzoneText}
								baseApi={process.env.REACT_APP_SIP_URL_FILES}
								removeFiles={this.handleRemoveFiles}
								uploadFiles={this.handleUploadFiles}
								files={item.attachments}
							/>
						</Grid>
					</Grid>
				</DialogContent>
				<DialogActions>
					<Button onClick={this.props.onClose} color='primary'>
						<Translate id='common.close' />
					</Button>
				</DialogActions>
			</Dialog>
		)
	}
}

const styles = () => ({
	deleteButton: {
		color: 'red',
	},
	gridItem: {
		marginBottom: 15,
	},
})

export default withStyles(styles, { withTheme: true })(ItemDialog)
